import Order, { OrderStatus } from "../ts/models/Order";
import axios from "../axios";
import Patient from "../ts/models/Patient";

const ORDER_URL = "/api/orders";
const ORDER_WITH_SIGNATURE = ORDER_URL + "/create-with-signature";
const SEND_LINKS_URL = "/sendlinks";

export function fetchOrder(id: string) {
  return axios({
    url: `${ORDER_URL}/${id}`,
    method: "get",
  });
}

export function fetchOrderWithPatient(id: string) {
  return axios({
    url: `${ORDER_URL}/${id}?patientDetails=${true}`,
    method: "get",
  });
}

export function addOrder(data: FormData) {
  return axios({
    url: ORDER_WITH_SIGNATURE,
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getPDF(id: string) {
  return axios({
    url: ORDER_URL + `/pdf/${id}`,
    method: "get",
    responseType: "blob",
  });
}

export function getQRCode(id: string) {
  return axios({
    url: ORDER_URL + `/qrcode/${id}`,
    method: "get",
    responseType: "blob",
  });
}

export function deactivateOrder(data: OrderStatus) {
  return axios({
    url: `${ORDER_URL}/${data.id}`,
    method: "put",
    data,
  });
}

export function resendOrders(podId: string, regEmail: string) {
  return axios({
    url: ORDER_URL + SEND_LINKS_URL + `?podId=${podId}&regEmail=${regEmail}`,
    method: "get",
  });
}

export function getMemberDetailsFromPortal(data: any) {
  return axios({
    url: "/api/patients/member-details",
    method: "post",
    data,
  });
}

export function getPatientDetailsFromPortal(data: any) {
  return axios({
    url: "/api/patients/patient-details",
    method: "post",
    data,
  });
}
